export default __webpack_public_path__ + "static/media/Savant's Boots of the Moon.1560e6d3.jpg";